import cx from 'classnames';
import type { FC, ReactNode } from 'react';

import { Headline } from '../../../Typography';

interface Props {
  actions?: ReactNode;
  classNames?: string;
  tagline?: ReactNode;
  title?: ReactNode;
}

const TableHeader: FC<Props> = ({ actions, classNames, tagline, title }) => {
  const renderHeaderInformation: boolean = !!title || !!tagline;

  const wrapperClassNames: string = cx(
    {
      'justify-between': renderHeaderInformation,
      'justify-end': !renderHeaderInformation
    },
    'flex items-center px-6 py-4 min-h-14 bg-white'
  );

  return (
    <div className={wrapperClassNames}>
      {renderHeaderInformation && (
        <div className="flex flex-col whitespace-nowrap justify-between">
          {title && (
            <Headline className={classNames} level={4}>
              {title}
            </Headline>
          )}
          {tagline && <p className="text-sm text-grey-base">{tagline}</p>}
        </div>
      )}
      {actions && (
        <div className="w-full flex justify-end" data-testid="table-header-actions">
          {actions}
        </div>
      )}
    </div>
  );
};

export default TableHeader;
